import { notifySimple } from "providers/toast";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import GenericDialog from "./generic";
import ReticulationForm, {
  ReticulationFormType,
} from "widgets/forms/tools/reticulation";
import {
  ReticulationCreateReqBody,
  ReticulationUpdateReqBody,
} from "api/types/reticulation";
import { addReticulation, updateReticulation } from "api/reticulation";
import { useNavigate } from "react-router-dom";

const ReticulationDialog = (props: {
  isOpen: boolean;
  context: "add" | "edit";
  values?: ReticulationFormType;
  onClose: (refresh: boolean) => void;
}) => {
  const { isOpen, context, values, onClose } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Function for linking a user
  const handleSubmit = async (formData: ReticulationFormType) => {
    dispatch(setLoading(true));
    if (context === "add") {
      const newReticulation: ReticulationCreateReqBody = {
        name: formData.name,
        sites: formData.sites,
        reticulationType: formData.reticulationType,
        config: formData.config,
      };
      const { data, status, isLoading } = await addReticulation(
        newReticulation
      );
      dispatch(setLoading(isLoading));
      if (status === 200 && data) {
        navigate(`/admin/tools/reactflow?id=${data._id}`);
      } else {
        notifySimple(t("notification.reticulation.add.error"), "error");
      }
    } else {
      const body: ReticulationUpdateReqBody = {
        id: values?._id,
        name: formData.name,
        sites: formData.sites,
        reticulationType: formData.reticulationType,
        config: formData.config,
      };
      const { status, isLoading } = await updateReticulation(body);
      dispatch(setLoading(isLoading));
      if (status === 200) {
        onClose(true);
        notifySimple(t("notification.reticulation.update.success"), "success");
      } else {
        notifySimple(t("notification.reticulation.update.error"), "error");
      }
    }
  };

  return (
    <GenericDialog
      isOpen={isOpen}
      title={t("dialog.add.reticulation.title", { context })}
      onExit={() => onClose(false)}
    >
      <ReticulationForm
        submit={handleSubmit}
        onClose={() => onClose(false)}
        values={values}
        context={context}
      />
    </GenericDialog>
  );
};

export default ReticulationDialog;
